export const normalizeTeamRole = (value) => {
  const role = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, '_');

  if (role === 'assistantcoach') return 'assistant_coach';
  if (role === 'subscriptionowner') return 'subscription_owner';
  if (
    role === 'coach' ||
    role === 'assistant_coach' ||
    role === 'analyst' ||
    role === 'player' ||
    role === 'subscription_owner'
  ) {
    return role;
  }
  if (role === 'superadmin' || role === 'admin' || role === 'owner') return role;
  return 'player';
};

export const isPlayerRole = (value) => normalizeTeamRole(value) === 'player';

export const canAccessDatabaseConfig = (value) => {
  const role = normalizeTeamRole(value);
  return role === 'coach' || role === 'assistant_coach';
};

export const canDeleteRecentSubmissions = (value) => {
  const role = normalizeTeamRole(value);
  return (
    role === 'subscription_owner' ||
    role === 'owner' ||
    role === 'coach' ||
    role === 'assistant_coach'
  );
};
